const sizesMap = {
    xs: '5px',
    sm: '15px',
    md: '30px',
    lg: '60px',
}

export enum Sizes {
    xxs = 'xxs',
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
}

export const defaultSize = undefined

export const sizes = Object.keys(sizesMap)

export default sizesMap
